import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useNotificationsState } from '@src/shared/context/notifications';
import Notification from '../Notification';
import useStyles from './styles';
import { useInsideDrawerState } from '@src/shared/context/inside-drawer';
import { DrawerType } from '../../context/inside-drawer/index';

const NotificationReporter = () => {
  const classes = useStyles();
  const { notificationsList, displayDuration } = useNotificationsState();
  const { activeDrawerState } = useInsideDrawerState();

  return (
    <>
      <TransitionGroup component={null}>
        <>
          {notificationsList.length > 0 && (
            <ul
              className={`${classes.notificationsList} ${
                activeDrawerState === (DrawerType.NOTIFICATION as any)
                  ? 'notificationDrawerOpen'
                  : ''
              }`}
            >
              {[...notificationsList]
                .map((notification) => (
                  <CSSTransition
                    timeout={100}
                    classNames="animated"
                    key={notification.id}
                  >
                    <div className={classes.notificationWrapper}>
                      <Notification
                        notification={notification}
                        displayDuration={displayDuration}
                        showCloseButton={
                          activeDrawerState !== (DrawerType.NOTIFICATION as any)
                        }
                        showNotificationTime={
                          activeDrawerState === (DrawerType.NOTIFICATION as any)
                        }
                      />
                    </div>
                  </CSSTransition>
                ))
                .reverse()}
            </ul>
          )}
        </>
      </TransitionGroup>
    </>
  );
};

export default NotificationReporter;
